import { z } from "zod";

export const emailReceived = z.object({
  type: z.literal("EmailReceived"),
  emailId: z.string().min(1),
  messageId: z.string().nullable().optional(),
  from: z.string(),
  to: z.string(),
  subject: z.string().nullable().optional(),
  bodyKey: z.string().min(1),
  attachmentKeys: z.array(z.string()).default([]),
});

export const emailRoutedToSite = z.object({
  type: z.literal("EmailRoutedToSite"),
  emailId: z.string().min(1),
  siteId: z.string().min(1),
  actorUserId: z.string().nullable().optional(),
});

export const emailUnresolved = z.object({
  type: z.literal("EmailUnresolved"),
  emailId: z.string().min(1),
  reason: z.string().optional(),
});

export const emailClassificationTypeSchema = z.enum([
  "sign_in_query",
  "compliance_document",
  "site_enquiry",
  "incident_report",
  "worker_request",
  "other",
]);
export type EmailClassificationType = z.infer<
  typeof emailClassificationTypeSchema
>;

export const emailClassified = z.object({
  type: z.literal("EmailClassified"),
  emailId: z.string().min(1),
  classification: emailClassificationTypeSchema,
  confidence: z.number().min(0).max(1),
  summary: z.string(),
});

export const emailEvents = [
  emailReceived,
  emailRoutedToSite,
  emailUnresolved,
  emailClassified,
] as const;
